import { ChevronLeftOutlineIcon } from '@ikyucom/design-system-icons-react'
import { ConditionsClear } from '~/features/guide/ConditionsClear'
import type { RestaurantId } from '~/lib/graphql/scalars'
import { Link } from '~/navigation'
import { sva } from '~/styled-system/css'

type Props = {
  restaurantId: RestaurantId
  buttonLabel?: string
  mainText: string
  subText?: string
  withClearButton?: boolean
}

const styles = sva({
  slots: ['container', 'title', 'text', 'sub', 'link', 'icon'],
  base: {
    container: {
      textAlign: 'center',
      w: 'full',
      _sd: {
        pb: '5',
      },
    },
    title: {
      mb: '3',
      fontFamily: 'serif',
      fontSize: '5xl',
      color: 'tertiary',
    },
    text: {
      fontSize: 'lg',
      color: 'gray.800',
    },
    sub: {
      mb: '5',
      whiteSpace: 'pre-wrap',
      fontSize: 'sm',
      color: 'gray.600',
    },
    link: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 'md',
      border: '[1px solid]',
      borderColor: 'button.tertiary.border',
      bg: 'white',
      p: '2',
      fontSize: 'sm',
      color: 'button.tertiary.text',
    },
    icon: {
      color: 'button.tertiary.icon',
      mr: '1',
    },
  },
})

export function NoCourse({
  restaurantId,
  buttonLabel,
  mainText,
  subText,
  withClearButton = false,
}: Props) {
  const classes = styles()
  return (
    <div className={classes.container}>
      <p className={classes.title}>Sorry...</p>
      <p className={classes.text}>{mainText}</p>
      {subText && <p className={classes.sub}>{subText}</p>}
      {withClearButton && <ConditionsClear />}
      {buttonLabel && (
        <Link to={`/${restaurantId}`} prefetch="viewport" className={classes.link}>
          <ChevronLeftOutlineIcon width={12} height={12} className={classes.icon} />
          {buttonLabel}
        </Link>
      )}
    </div>
  )
}
